import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogTitle, IconButton, Typography } from '@mui/material';
import React from 'react';

import { useModalClose } from '../../hooks';

interface IProps {
  title: string;
  onClose: () => void;
}

const ModalHeader: React.FC<IProps> = ({ title, onClose }) => {
  const handleClose = useModalClose({ onClose });

  return (
    <DialogTitle sx={{ height: 62 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">{title}</Typography>
        <IconButton aria-label="close" onClick={handleClose} data-action="close_modal_btn">
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
  );
};

export default ModalHeader;
